'use client'

import { useEffect } from 'react'
import { AnimatePresence } from '@nwwp/ui-shadcn'
import { getTrackingParams } from '~/utils/tracking'
import { FlowStepViewed } from './analytics/FlowStepViewed'
import { BackButton } from './BackButton'
import type { Steps } from '../utils'
import { Age } from './steps/Age'
import { Email } from './steps/Email'
import { HouseholdIncome } from './steps/HouseholdIncome'
import { Investment } from './steps/Investment'
import { MaritalStatus } from './steps/MaritalStatus'
import { Name } from './steps/Name'
import { Phone } from './steps/Phone'
import { RedirectToMatch } from './steps/RedirectToMatch'
import { Schedule } from './steps/Schedule'
import { VerifyPhone } from './steps/VerifyPhone'
import { ZipCode } from './steps/ZipCode'
import { useFunnel } from '../_hooks/use-funnel'
import { useFunnelStore } from '../_hooks/use-funnel-store'

const steps: Steps<{ disqualifiedByAge: boolean; disqualifiedByAssets: boolean }> = [
  Age,
  { type: 'terminal', condition: 'disqualifiedByAge', render: RedirectToMatch },
  ZipCode,
  MaritalStatus,
  Investment,
  HouseholdIncome,
  { type: 'terminal', condition: 'disqualifiedByAssets', render: RedirectToMatch },
  Name,
  Email,
  Phone,
  VerifyPhone,
  { type: 'terminal', render: Schedule },
]

export const LeadForm = () => {
  const {
    data: { age, investable_assets_range = '', household_income = 0 },
    setTracking,
    trackingInitialized,
  } = useFunnelStore()

  useEffect(() => {
    setTracking(getTrackingParams())
  }, [setTracking])

  const { currentStep, handleSubmit, handlePrevious, isInBetweenStep } = useFunnel(steps, {
    disqualifiedByAge: Boolean(age && (age < 27 || age > 55)),
    disqualifiedByAssets: Boolean(investable_assets_range === 'UNDER_100K' && household_income < 100_000),
  })
  const Step = currentStep?.render

  return (
    <AnimatePresence>
      {Step && (
        <AnimatePresence.Fade key={currentStep.path} className="w-full">
          <div className="flex w-full flex-col gap-5 tablet:gap-10">
            {isInBetweenStep && <BackButton onClick={handlePrevious} />}
            <FlowStepViewed step={currentStep.path} type={currentStep.type} enabled={trackingInitialized}>
              <Step onSubmit={handleSubmit} />
            </FlowStepViewed>
          </div>
        </AnimatePresence.Fade>
      )}
    </AnimatePresence>
  )
}
